// SteffiAvatarDemo.jsx
import React from "react";
import SteffiAvatarPlayer from "./SteffiAvatarPlayer";
import { TALK_LOOP, SLEEP_LOOP, NEUTRAL_BLINK, MUSIC } from "./sequences";

export default function SteffiAvatarDemo2() {
  return (
    <div className="flex flex-col items-center gap-8">
      {/* Talking animation */}
      <div className="flex flex-col items-center gap-2">
        <div className="text-sm opacity-70">Talking</div>
        <SteffiAvatarPlayer sequence={TALK_LOOP} className="w-48" />
      </div>

      {/* Neutral with blinking */}
      <div className="flex flex-col items-center gap-2">
        <div className="text-sm opacity-70">Neutral (blink)</div>
        <SteffiAvatarPlayer sequence={NEUTRAL_BLINK} className="w-48" />
      </div>

      {/* Sleeping (Zzzz) */}
      <div className="flex flex-col items-center gap-2">
        <div className="text-sm opacity-70">Sleeping</div>
        <SteffiAvatarPlayer sequence={SLEEP_LOOP} className="w-48" />
      </div>

       <div className="flex flex-col items-center gap-2">
        <div className="text-sm opacity-70">Music</div>
        <SteffiAvatarPlayer sequence={MUSIC} className="w-48" />
      </div>
    </div>
  );
}